module.exports = __webpack_public_path__ + "static/media/client31.01d02127.webp";